import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import 'flag-icons/css/flag-icons.min.css';

class LanguageSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  toggleDropdown = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  handleLanguageSelect = (countryCode) => {
    this.setState({ isOpen: false });
    this.props.onSelect(countryCode);
  };

  getFlagClass = (countryCode) => {
    const flagMap = {
      'GB': 'gb',
      'ES': 'es', 
      'ES-CT': 'es-ct'
    };
    return `fi fi-${flagMap[countryCode]}`;
  };

  getLanguageLabel = (countryCode) => {
    const labels = {
      'GB': 'English',
      'ES': 'Español',
      'ES-CT': 'Català'
    };
    return labels[countryCode];
  };

  render() {
    const { selected } = this.props;
    const languages = ['GB', 'ES', 'ES-CT'];

    return (
      <Dropdown show={this.state.isOpen} onToggle={this.toggleDropdown}>
        <Dropdown.Toggle 
          variant="outline-light" 
          id="language-dropdown"
          size="sm"
          className="d-flex align-items-center"
          style={{ border: 'none', background: 'transparent' }}
        >
          <span 
            className={this.getFlagClass(selected)} 
            style={{ marginRight: '8px', width: '20px', height: '15px' }}
          ></span>
          <span className="d-none d-md-inline">{this.getLanguageLabel(selected)}</span>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {languages.map((countryCode) => (
            <Dropdown.Item
              key={countryCode}
              onClick={() => this.handleLanguageSelect(countryCode)}
              className="d-flex align-items-center"
              active={selected === countryCode}
            >
              <span 
                className={this.getFlagClass(countryCode)} 
                style={{ marginRight: '8px', width: '20px', height: '15px' }}
              ></span>
              {this.getLanguageLabel(countryCode)}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default LanguageSelector;
